import script from "./FloatMenuHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatMenuHeader.vue?vue&type=script&setup=true&lang=js"

import "./FloatMenuHeader.vue?vue&type=style&index=0&id=b462c0b8&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b462c0b8"]])

export default __exports__